<template>
  <BookingErrorModal :name="name">
    <template #action="{ params }">
      <FreeButton
        type="button"
        class="green-main-button w-full"
        @click="emit('onCancelPrevBooking')"
      >
        {{ $t('contacts.errors.doubleBooking.cancelAndProceed') }}
      </FreeButton>
      <FreeButton
        type="button"
        class="gray-button w-full"
        @click="emit('onProceedToExistingBooking', params.orderId)"
      >
        {{ $t('contacts.errors.doubleBooking.proceedToExistingBooking') }}
      </FreeButton>
    </template>
  </BookingErrorModal>
</template>

<script setup lang="ts">
  import { FreeButton } from 'freedom-shared';

  import { BookingErrorModal } from '@/entities/booking-error-modal';

  defineProps<{
    name: string;
  }>();

  const emit = defineEmits<{
    (e: 'onCancelPrevBooking'): void;
    (e: 'onProceedToExistingBooking', orderId: unknown): void;
  }>();
</script>
